import Draggable from 'react-draggable';
import DragPoint from '@/public/icons/record/drag.svg';
import Enlargement from '@/public/icons/record/enlargement.svg';
import { formatAudioTime2 } from '@/utils/function';
import SvgImage from '@/components/Module/SvgImage';
import TalkFLowModal, {
  TalkFlowModalRef,
} from '@/components/Record/TalkFLowModal';
import React, { useRef } from 'react';
import AnimationOpen from '@/components/MobileSales/Contents/AnimationOpen';
import {
  BottomContainer,
  ButtonContainer,
  Container,
  StyledTime,
  StyledTitle,
  TopContainer,
} from './styles';
import { SvgBoxButton } from '@/components/Record/VoiceRecord2/styles';
import { useRecorder } from '@/components/RecorderProvider';
import CustomVoiceVisualizer from '@/components/Record/VoiceRecord2/CustomVoiceVisualizer';

const DraggableRecord = () => {
  const {
    controls,
    state,
    stop,
    recordingTime,
    pauseResume,
    isPausedRecording,
  } = useRecorder();
  const recordDetailModalRef = useRef<TalkFlowModalRef>(null);
  const draggableNodeRef = useRef(null);
  const openRecordDetailModal = () => {
    recordDetailModalRef.current?.open(state.docId);
  };
  const recordStop = () => {
    recordDetailModalRef.current?.open(state.docId);
    stop();
  };

  return (
    <>
      <TalkFLowModal ref={recordDetailModalRef} />
      {state.openDraggable && (
        <AnimationOpen>
          <Draggable nodeRef={draggableNodeRef}>
            <Container ref={draggableNodeRef}>
              <TopContainer>
                <ButtonContainer>
                  <DragPoint />
                </ButtonContainer>
                <StyledTitle>{state.title}</StyledTitle>
                <ButtonContainer onClick={openRecordDetailModal}>
                  <Enlargement />
                </ButtonContainer>
              </TopContainer>
              <BottomContainer>
                <div
                  style={{
                    minWidth: '106px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <CustomVoiceVisualizer
                    controls={controls}
                    width={106}
                    height={24}
                    speed={1}
                  />
                </div>
                <StyledTime>{formatAudioTime2(recordingTime)}</StyledTime>
                <SvgBoxButton
                  onClick={pauseResume}
                  style={{ marginLeft: '8px', padding: '8px' }}
                >
                  <SvgImage name={isPausedRecording ? 'play' : 'pause'} />
                </SvgBoxButton>
                <SvgBoxButton
                  onClick={recordStop}
                  style={{ marginLeft: '8px', padding: '8px' }}
                >
                  <SvgImage name={'stop'} />
                </SvgBoxButton>
              </BottomContainer>
            </Container>
          </Draggable>
        </AnimationOpen>
      )}
    </>
  );
};
export default DraggableRecord;
